window.addEventListener("DOMContentLoaded", () => {
    setTimeout(async () => {
        const hostname = location.hostname;
        const target = "_blank";
        const rel = "noreferrer noopener";
        [...document.links]
            .filter((l) => {
                return (
                    l.protocol.indexOf("http") === 0 && l.hostname != hostname && l.target !== target && l.rel !== rel
                );
            })
            .forEach((l) => {
                l.target = target;
                l.rel = rel;
            });
    }, 0);
});
